export default {
    EventName: {
        Delete: 'Xóa',
        View: 'Xem',
        Save: 'Lưu',
        SaveAdd: 'Lưu và thêm mới',
        SaveClose: 'Lưu và đóng',
        SaveView: 'Lưu và xem',
        Edit: 'Sửa',
        Duplicate: 'Nhân bản',
        Add: 'Thêm mới',
        Active: 'Theo dõi',
        Unactive: 'Ngừng theo dõi',
        Complete: 'Hoàn thành',
        SendBack: 'Gửi trả',
        CancelComplete: 'Hủy hoàn thành',
        Change: 'Thay đổi',
    },
    ScreenName: {
        Dictionary_BudgetRevenue: 'Danh mục Thu ngân sách Nhà nước',
        Dictionary_RevenueBusiness: 'Danh mục Thu HĐSN & dịch vụ',
        Dictionary_RevenueFee: 'Danh mục Thu phí, Lệ phí',
        Dictionary_RevenueOther: 'Danh mục Thu phí, Lệ phí',
        Dictionary_Invest: 'Danh mục Chi đầu tư phát triển',
        Dictionary_Regular: 'Danh mục Chi thường xuyên',
        Dictionary_ExpenseOther: 'Danh mục Chi thường xuyên',
        Dictionary_Chapter: "Danh mục Chương",
        Dictionary_Kind: "Danh mục Loại - khoản",
        Dictionary_BudgetItem: "Danh mục Mục - tiểu mục",
        Dictionary_Source: "Danh mục Nguồn kinh phí",
        Dictionary_Source: "Danh mục Nguồn kinh phí",
        Dictionary_PatternRegular: "Danh mục Mẫu dự toán chi thường xuyên",
        Dictionary_Explanation: "Danh mục Thuyết minh",
        Dictionary_CalculationBasis: "Danh mục Cơ sở tính",
        Dictionary_Criteria: "Danh mục Tiêu chí thống kê",
        Dictionary_ReportCustomList: "Danh mục Mẫu in tùy chỉnh",
        DictionaryPresentCustom: 'Danh mục Mẫu in tùy chỉnh', // Added based on usage

        // ---- Estimate -------------
        Estimate_RevenueBudget: "Lập dự toán - Thu NSNN", // Placeholder, adjust as needed
        Estimate_Invest: "Lập dự toán - Chi đầu tư phát triển", // Placeholder, adjust as needed
        Estimate_Regular: "Lập dự toán - Chi thường xuyên", // Placeholder, adjust as needed
        Estimate_Project: "Lập dự toán - CTMT, dự án", // Placeholder, adjust as needed
        Estimate_ExpenseOther: "Lập dự toán - Chi hoạt động khác", // Placeholder, adjust as needed
        Estimate_RevenueOther: "Lập dự toán - Thu hoạt động khác", // Placeholder, adjust as needed
        Estimate_ExpenseBusiness: "Lập dự toán - Chi HĐSN & dịch vụ", // Placeholder, adjust as needed
        Estimate_RevenueBusiness: "Lập dự toán - Thu HĐSN & dịch vụ", // Placeholder, adjust as needed
        Estimate_ExpenseFees: "Lập dự toán - Chi phí, lệ phí", // Placeholder, adjust as needed
        Estimate_RevenueFees: "Lập dự toán - Thu phí, lệ phí", // Placeholder, adjust as needed
        CreateEstimate: 'Lập dự toán nhu cầu', // Added based on usage
        CreateEstimateInitial: 'Lập dự toán đầu năn', // Added based on usage

        // ---- Summary Estimate ----
        SummaryEstimate: 'Tổng hợp dự toán nhu cầu', // Added based on usage
        SummaryAudit: 'Tổng hợp dự toán',
        // ---- Submit Estimate ----
        SubmitEstimateList: 'Nộp dự toán', // Added based on usage

        // ---- Examine -------------
        Examine: 'Kiểm tra dự toán nhu cầu', // Added based on usage
        ExamineComplete: 'Hoàn thành biên bản kiểm tra', // Added based on usage
        ExamineFeedBack: 'Kiểm tra dự toán nhu cầu', // Added based on usage
        ExamineListForm: 'Kiểm tra dự toán', // Added based on usage
        ExamineDetail: 'Kiểm tra dự toán', // Added based on usage

        // ---- Allocation Implement ----
        AllocationImplement: 'Phân bổ dự toán', // Added based on usage
        AllocationImplementList: 'Phân bổ dự toán', // Added based on usage
        AllocationImplementListPopup: 'Phân bổ dự toán', // Added based on usage

        // ---- Sync Dictionary ----
        SyncDictionary: 'Đồng bộ danh mục', // Added based on usage

    }
};
